import { getConferenceState } from '../../../../react/features/base/conference/functions';
import { isNoiseSuppressionEnabled } from '../../../../react/features/noise-suppression/functions';
import { isScreenAudioShared } from '../../../../react/features/screen-share/functions';
import { getUTCTimestamp, getWildixPlatform, removeStorageData, setStorageData } from '../../../functions.any';
import { KIBANA_MESSAGES, NUMBER_ELEMENTS_TO_SEND } from './constants';
import { buildBaseStats, getDisconnectInfo, getRoomToken, getSharingVariant, getUserDataFromPresence, isKibanaLogsEnabled, removeMediaFieldsFromStats, sendFetchData } from './functions';
let connectionStats = [];
let isUserCanSendLogs = true;
export function saveDisconnectInfo(disconnectReason) {
    return (dispatch, getState) => {
        const state = getState();
        const { conference } = state['features/base/conference'];
        if (!conference) {
            return;
        }
        const conferenceRoom = conference.room;
        if (!conferenceRoom) {
            return;
        }
        const xmpp = conferenceRoom.xmpp;
        const info = {
            disconnectReason,
            disconnectStartTime: getUTCTimestamp(),
            // @ts-ignore
            isXmppConnected: xmpp?.connection?.connected || false,
            // @ts-ignore
            iceConnectionState: conference.getConnectionState() || '',
            // @ts-ignore
            transport: conference.connectionQuality.getStats().transport
        };
        setStorageData(`disconnectInfo_${getRoomToken(getState)}`, JSON.stringify(info));
    };
}
export function onConnectionStatsUpdate(stats) {
    return (dispatch, getState) => {
        const state = getState();
        // When enough stats have been collected, send them.
        if (connectionStats.length >= NUMBER_ELEMENTS_TO_SEND) {
            const message = KIBANA_MESSAGES.UserNetworkStatus;
            dispatch(sendStatsToKibana(connectionStats, message));
            connectionStats = [];
        }
        const filteredStats = removeMediaFieldsFromStats(stats);
        // Build the common (base) stats for both platforms.
        const baseStats = buildBaseStats(state, filteredStats);
        let finalStats = {};
        // For Web (non ReactNative), extend the base stats with additional details.
        if (navigator.product !== 'ReactNative') {
            finalStats = {
                ...baseStats,
                sharingVariant: getSharingVariant(state),
                isNoiseSuppressionEnabled: isNoiseSuppressionEnabled(state),
                isScreenAudioShared: Boolean(isScreenAudioShared(state))
            };
        }
        else {
            // For React Native, you can extend the base stats minimally if needed.
            finalStats = {
                ...baseStats
            };
        }
        // Push the final stats object into the global array.
        connectionStats.push(finalStats);
    };
}
export function sendStatsToKibana(connectionStatsProp, message) {
    return (dispatch, getState) => {
        const state = getState();
        const { conference } = getConferenceState(state);
        if (!connectionStatsProp.length || !isUserCanSendLogs
            || !conference || !isKibanaLogsEnabled(state)) {
            return;
        }
        const { displayName, websocketUser, email, ctijid, ctiextension, userId, room } = getUserDataFromPresence(conference);
        // @ts-ignore
        // eslint-disable-next-line max-len
        const { pbxHost, pbxVersion, pbxSerial, isExternalMeeting, channelMembersNumber } = state['features/base/config'] || {};
        const informationAboutPBX = {};
        if (ctijid) {
            informationAboutPBX.pbxHost = pbxHost;
            informationAboutPBX.pbxVersion = pbxVersion;
            informationAboutPBX.pbxSerial = pbxSerial;
            informationAboutPBX.pbxExtension = ctiextension;
        }
        const connectionStatsExtendedData = connectionStatsProp.map((object) => {
            return {
                ...object,
                ...informationAboutPBX,
                displayName,
                userId,
                websocketUser,
                channelMembersNumber,
                isExternalMeeting,
                email,
                isPbxUser: Boolean(ctijid),
                userAgent: navigator?.userAgent ?? 'UserAgent not detected',
                platform: navigator?.platform ?? navigator?.product ?? 'Platform not detected',
                wildixPlatform: getWildixPlatform(conference)
            };
        });
        const obj = {
            room,
            message,
            data: {
                connectionStats: connectionStatsExtendedData
            }
        };
        sendFetchData(obj).catch(() => {
            isUserCanSendLogs = false;
        });
    };
}
export function sendStatsDisconnectedRoom() {
    return (dispatch, getState) => {
        const { disconnectStartTime, ...disconnectInfo } = getDisconnectInfo(getState);
        const disconnectEndTime = getUTCTimestamp();
        if (!disconnectStartTime) {
            return;
        }
        removeStorageData(`disconnectInfo_${getRoomToken(getState)}`);
        if (disconnectEndTime - Number(disconnectStartTime) > 3600) {
            return;
        }
        const getRandomInt = (max) => Math.floor(Math.random() * Math.floor(max));
        setTimeout(() => {
            const message = KIBANA_MESSAGES.RoomDisconnected;
            const connectionStatsObject = {
                disconnectStartTime: Number(disconnectStartTime),
                disconnectEndTime,
                ...disconnectInfo
            };
            dispatch(sendStatsToKibana([connectionStatsObject], message));
        }, (getRandomInt(5) || 1) * 1000);
    };
}
